import styled, { css } from 'styled-components';
import {} from './index.js';
import { getMargins, SYS_BREAKPOINT_MD, SYS_SPACE_FIXED_100 } from '@oneaudi/unified-web-common';
export const StyledButtonGroupContainer = styled.div `
  margin: ${(props) => getMargins(props.margin)};
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  align-items: flex-start;

  ${(props) => props.$orientation === 'horizontal' &&
    !props.containsIconButtonOrLink &&
    css `
      flex-direction: column;

      @media (min-width: ${SYS_BREAKPOINT_MD}) {
        flex-direction: row;
      }
    `}

  ${(props) => props.$orientation === 'vertical' &&
    !props.containsIconButtonOrLink &&
    css `
      flex-direction: column;
    `};

  ${(props) => props.containsIconButtonOrLink &&
    css `
      flex-direction: row;
    `}
`;
//# sourceMappingURL=index.styles.js.map